import { render } from "./ClipPath.vue?vue&type=template&id=5f6ec2cc&scoped=true&ts=true"
import script from "./ClipPath.vue?vue&type=script&lang=ts"
export * from "./ClipPath.vue?vue&type=script&lang=ts"

import "./ClipPath.vue?vue&type=style&index=0&id=5f6ec2cc&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6ec2cc"]])

export default __exports__